export default __webpack_public_path__ + "static/headerimage-spiritualrestoration-0d9cbf7c4af7ba8060ecf6d702759f15.jpg";